import { memo } from 'react';
import styled from 'styled-components';
import { useEventContext, useInteractionContext } from '../../context';

const Square = styled.rect<{ $hovered: boolean; $color: string }>`
  transform-box: fill-box;
  transform-origin: center center;
  width: ${props => (props.$hovered ? 14 : 12)}px;
  height: ${props => (props.$hovered ? 14 : 12)}px;
  transform: translate(-50%, -50%) rotate(45deg) ${props => (props.$hovered ? 'scale(1.1)' : '')};
  fill: ${props => props.$color};
  opacity: 1;
  transition: transform 0.2s;
`;

const Dot = styled.circle<{ $hovered: boolean; $color: string }>`
  transform-box: fill-box;
  transform-origin: center center;
  r: 6px;
  fill: ${props => props.$color};
  opacity: 1;
  transform: ${props => (props.$hovered ? 'scale(1.2)' : '')};
  transition: transform 0.2s;
`;

const Dots = memo(
  ({ data, keyX, keyY, scaleX, scaleY, color, Component, square, id: seriesId, ...props }: any) => {
    const { handleMouseEnter, handleMouseLeave, handleClick } = useEventContext();
    const { isHovered, isSelected } = useInteractionContext();
    return data.map((d: any, i: any) => {
      const id = `${seriesId}-${i}`;
      return d[keyY] > 0 ? (
        square ? (
          <Square
            key={i}
            x={scaleX(keyX ? d[keyX] : i)}
            y={scaleY(0)}
            $color={color}
            $hovered={isHovered(id) || isSelected(id)}
            onClick={event => handleClick(id, event)}
            onMouseEnter={event => handleMouseEnter(id, event)}
            onMouseLeave={event => handleMouseLeave(id, event)}
            {...props}
          />
        ) : (
          <Dot
            key={i}
            cx={scaleX(keyX ? d[keyX] : i)}
            cy={scaleY(0)}
            $color={color}
            $hovered={isHovered(id) || isSelected(id)}
            onClick={event => handleClick(id, event)}
            onMouseEnter={event => handleMouseEnter(id, event)}
            onMouseLeave={event => handleMouseLeave(id, event)}
            {...props}
          />
        )
      ) : null;
    });
  },
);

export default Dots;
